<p-progressSpinner
	ariaLabel="loading"
	[styleClass]="spinnerClass"
	[strokeWidth]="strokeWidth()"
	fill="transparent"
	animationDuration="1.5s">
</p-progressSpinner>
